import { createModel } from 'xstate/lib/model';

import { KybDocumentType, KycReviewDocumentType } from '__generated__/GQL';
import baseEvents from 'common/bento/config/baseEvents';
import { FunctionReturn } from 'features/Bento/types/helpers';

import {
  AddressSchema,
  getDefaultAddress,
} from '../../../components/AddressForm/addressSchema';
import { ProofOfAddressModuleDataQuery } from '../graphql/queries/proofOfAddressModuleData.gql';
import { Services } from './services';

export type PoaType =
  | 'ELECTRICITY'
  | 'INTERNET'
  | 'INCOME_TAX_NOTICE'
  | 'GAZ_OR_WATER_BILL'
  | 'LANDLINE';

export type DocumentFile = {
  url: string;
  firebaseBucket: string;
  firebaseRef: string;
  type: KycReviewDocumentType | KybDocumentType;
};

export type AddressModuleData = ProofOfAddressModuleDataQuery & {
  isShineStart: boolean;
};

export type Context = {
  address: AddressSchema;
  documentFile: DocumentFile | null;
  getModuleData: () => AddressModuleData;
  poaType: PoaType | null;
};

const initialContext: Context = {
  address: getDefaultAddress(),
  documentFile: null,
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
  poaType: null,
};

const creators = {
  events: {
    ...baseEvents,

    DELETE_DOCUMENT_FILE: (kycDocumentId: string) => ({ kycDocumentId }),
    'done.invoke.loadInitialData': (
      data: FunctionReturn<Services['loadInitialData']>,
    ) => ({
      data,
    }),
    'done.invoke.sendAddress': (
      data: FunctionReturn<Services['sendAddress']>,
    ) => ({ data }),
    EDIT_ADDRESS: () => ({}),
    GO_HOSTED_ACCOMMODATION: () => ({}),
    GO_HOSTED_HOME: () => ({}),
    GO_HOSTED_HOST_ID: () => ({}),

    GO_HOSTED_POA: () => ({}),
    GO_POA: () => ({}),
    GO_POA_TYPE_OTHER: () => ({}),
    SUBMIT_ADDRESS: (data: AddressSchema) => ({ data }),

    SUBMIT_DOCUMENT_FILE: (data: DocumentFile) => ({ data }),
    SUBMIT_POA_TYPE: (data: PoaType) => ({ data }),
  },
};

const model = createModel(initialContext, creators);

export default model;

export type Model = typeof model;
